/* eslint-disable */
import React from 'react'
import PropTypes from 'prop-types'
import groupBy from 'lodash.groupby'
import CampusGroup from './CampusGroup'

const Payments = ({rows=[],search=false}) => {
  function render(rows,search){
    if(!search) return (<div className="well"><blockquote>Please fill in the campus and contractor name to view the latest payments.</blockquote></div>);
    if(rows.length == 0) return (<div className="well"><blockquote style={{fontWeight:'bold'}}>No Payments Found</blockquote></div>);

    // Group By Campus
    // ===============
    const grouped = groupBy(rows,'CAMPUS');

    // Get array of Campuses
    // =====================
    const groups = Object.keys(grouped);

    // Only one campus returned?
    // =========================
    const isSingleCampus = groups.length === 1;

    // Display Campus Groups
    // =====================
    return groups.map((prop,i)=>{
      return <CampusGroup key={`Payment-Group-Row-${i}`}
                          isSingleCampus={isSingleCampus}
                          data={grouped[prop]}
                          title={prop}/>
    })
  }
  return (
    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 payments">
      <div>
        {render(rows,search)}
      </div>
    </div>
  )
};

Payments.propTypes = {
  payments: PropTypes.array
};

export default Payments;


// WEBPACK FOOTER //
// ./src/components/Payments/Payments.jsx